export const TIKTOK_EXPERIMENTAL_VIEW_MODE =
  process.env.REACT_APP_TIKTOK_EXPERIMENTAL_VIEW_MODE === "true" ||
  (process.env.NODE_ENV === "development" && process.env.REACT_APP_TIKTOK_EXPERIMENTAL_VIEW_MODE !== "false");

export function experimentEnabled() {
  return TIKTOK_EXPERIMENTAL_VIEW_MODE;
}

export function validTikTokView(value) {
  return ["cards", "table", "market"].includes(value) ? value : null;
}
